export default ['None', 'OAuth']